const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100vh] text-text-primary capitalize text-lg font-medium gap-4">
      <svg
        className="animate-spin h-20 w-20 text-red-500"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 100 16v-4l-3.5 3.5L12 24v-4a8 8 0 01-8-8z"
        ></path>
      </svg>
      <p>{message}</p>
    </div>
  );
};

export default LoadingSpinner;

// const SkeletonLoader = ({ message = "Loading...", type = "spinner" }) => {
//   return (
//     <div className="w-full box-border flex flex-col items-center justify-center h-screen w-full px-4 bg-background-color-primary text-text-primary dark:bg-gray-900 dark:text-white">
//       {type === "spinner" ? (
//         <>
//           <svg
//             className="animate-spin h-10 w-10 text-blue-600"
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//           >
//             <circle
//               className="opacity-25"
//               cx="12"
//               cy="12"
//               r="10"
//               stroke="currentColor"
//               strokeWidth="4"
//             ></circle>
//             <path
//               className="opacity-75"
//               fill="currentColor"
//               d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 100 16v-4l-3.5 3.5L12 24v-4a8 8 0 01-8-8z"
//             ></path>
//           </svg>
//           <p className="mt-4 text-lg font-medium">{message}</p>
//         </>
//       ) : (
//         <>
//           <div className="w-full box-border space-y-4 animate-pulse">
//             <div className="h-6 bg-gray-500 rounded dark:bg-gray-700 w-3/4 box-border"></div>
//             <div className="h-4 bg-gray-500 rounded dark:bg-gray-700 w-full box-border"></div>
//             <div className="h-4 bg-gray-500 rounded dark:bg-gray-700 w-5/6 box-border"></div>
//             <div className="h-4 bg-gray-500 rounded dark:bg-gray-700 w-4/5 box-border"></div>
//             <div className="h-48 bg-gray-500 rounded-lg dark:bg-gray-700 w-full box-border"></div>
//           </div>
//           <p className="mt-6 text-base font-medium opacity-70">{message}</p>
//         </>
//       )}
//     </div>
//   );
// };

// export default SkeletonLoader;
